import { render, staticRenderFns } from "./PresTableStories.vue?vue&type=template&id=14bc38bf"
import script from "./PresTableStories.vue?vue&type=script&lang=js"
export * from "./PresTableStories.vue?vue&type=script&lang=js"
import style0 from "./PresTableStories.vue?vue&type=style&index=0&id=14bc38bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports